import 'css-chunksrc/client/scenes/optimizedGantt/graph/elementsOverlay/element/task/styles.scss';export default {
  "task": "_task_cf564_1",
  "hovered": "_hovered_cf564_12",
  "completed": "_completed_cf564_15",
  "late": "_late_cf564_15",
  "unScheduled": "_unScheduled_cf564_19",
  "withStartDate": "_withStartDate_cf564_26",
  "withEndDate": "_withEndDate_cf564_33",
  "blocked": "_blocked_cf564_47",
  "derived": "_derived_cf564_75",
  "completedAtEndDate": "_completedAtEndDate_cf564_94",
  "name": "_name_cf564_99"
};